export default "__VITE_ASSET__ChP2KdF___"